import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SELECT_ZONES from 'constants/amPmSelect';

const AmPmSection = ({ amPm, onChange, name, title, ariaLabel, disabled }) => (
  <div className="form-group">
    <select
      className="form-control time-select"
      onChange={onChange}
      name={name}
      role="listbox"
      title={title}
      aria-label={ariaLabel}
      tabIndex="0"
      defaultValue={amPm || ''}
      disabled={disabled}
    >
      {_.map(SELECT_ZONES, (label, value) => (
        <option value={value} key={value}>
          {label}
        </option>
      ))}
    </select>
  </div>
);

AmPmSection.propTypes = {
  amPm: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

AmPmSection.defaultProps = {
  onChange: () => { },
  amPm: ''
};

export default AmPmSection;
